import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

import VerificationSummaryTable from "./VerificationSummaryTable";

type Props = {
  external_reference: string;
};

export default graphql<any, Props>(
  gql`
    query details($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        risk_assessment {
          risk_status
          created_at
          updated_at
        }
        identity_verification {
          status
          created_at
          updated_at
        }
        automatic_verification_request {
          status
          created_at
          updated_at
        }
        manual_verification_request {
          status
          created_at
          updated_at
        }
      }
    }
  `,
  {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        external_reference: props.external_reference,
      },
    }),
  }
)((props) => (
  <BOGraphQLLoader data={props.data!}>
    <VerificationSummaryTable user={props.data.user} />
  </BOGraphQLLoader>
));
